import { type ColumnFilterItem } from 'antd/es/table/interface';

import { type ISelectOption } from '@/components/Shared/ui/select/select';

export enum Status {
  active = 'active',
  disabled = 'disabled'
}

enum StatusLabel {
  active = 'Активно',
  disabled = 'Неактивно'
}

export const statusLabelMapper: Record<Status, StatusLabel> = {
  [Status.active]: StatusLabel.active,
  [Status.disabled]: StatusLabel.disabled
};

export const statusOptions = Object.values(Status).map(
  (item): ISelectOption => ({
    value: item,
    label: statusLabelMapper[item]
  })
);

export const statusOptionsColumn = Object.values(Status).map(
  (item): ColumnFilterItem => ({
    text: statusLabelMapper[item],
    value: item
  })
);

export const statusBooleanOptionsColumn = Object.values(Status).map(
  (item): ColumnFilterItem => ({
    text: statusLabelMapper[item],
    value: String(item === Status.active)
  })
);
